// extracted by mini-css-extract-plugin
export var auto = "button-module--auto--5996e";
export var black = "button-module--black--f1127";
export var button = "button-module--button--77797";
export var buttonInner = "button-module--buttonInner--744a2";
export var copy = "button-module--copy--48223";
export var full = "button-module--full--30e27";
export var gold = "button-module--gold--38877";
export var solid = "button-module--solid--387a2";